import {t} from './catalogueUi';

export const labelWithUnit = (labelKey: string, unitKey: string) =>
  `${t(labelKey)} (${t(unitKey)})`;
